<!-- eslint-disable -->
<template lang="pug">
    .settings(v-if='settings')
        | {{ $i18n.t('trainer.trainer_gameFormSetting_mode') }}: {{ getModeName(settings.mode) }}
        br
        | {{ $i18n.t('trainer.trainer_gameFormSetting_difficulty') }}: {{ difficult }}
        br
        | {{ $i18n.t('trainer.trainer_gameFormSetting_gameWithTime') }}: {{ abbreviatedValueOfSetting(settings.withTime) }}
        br
        template(v-if="settings.speed && parametersFrom === 'homework'")
            | {{ $i18n.t('trainer.trainer_gameFormSetting_displaySpeed') }}:
            | {{ settings.speed }}
            | {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
            br
        template(v-if='settings.amountOfActions')
            | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfActions') }}:
            | {{ settings.amountOfActions }}
            br
        template(v-if='settings.amountOfExamples')
            | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}:
            | {{ settings.amountOfExamples }}
            br
        template(v-if='settings.isSpeedIncrease')
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_acceleration') }}:
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_ForLowerCase') }}
                | {{ settings.speedUp }}
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_After') }}
                | {{ amountOfSpeedExercises }}
            br
        template(v-if='settings.isComplication')
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_complication') }}:
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_ForLowerCase') }}
                | {{ amountOfActions }}
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_After') }}
                | {{ amountOfComplicationExercises }}
            br
        template(v-if='jumpOver')
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_jumpOverPriority') }}:
                | {{ jumpOver }}
            br
        template(v-if="parametersFrom !== 'course' && answers")
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_answers') }}:
                | {{ answers }}
            br
        template(v-if='settings.fractions')
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_fractions') }}:
                | {{ fractionalPart }}
                | {{ $i18n.t('trainer.trainer_gameFormSetting_afterPoint') }}
            br
        template(v-if='settings.mirror')
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_mirror') }}:
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
            br
        template(v-if='settings.roundNumbers')
            span
                | {{ $i18n.t('trainer.trainer_gameFormSetting_roundNumbers') }}:
                | {{ $i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated') }}
            br
        template(v-if="parametersFrom !== 'course' || settings.withTime && settings.extraOptions")
            | {{ $i18n.t('trainer.trainer_gameFormSetting_distractingPictures') }}:
            | {{ abbreviatedValueOfSetting(settings.extraOptions.pictures) }}
            br
            | {{ $i18n.t('trainer.trainer_gameFormSetting_music') }}:
            | {{ abbreviatedValueOfSetting(settings.extraOptions.music) }}
            br
            | X2:
            | {{ abbreviatedValueOfSetting(settings.extraOptions.x2) }}
            br
            | {{ motionLabel }}:
            | {{ abbreviatedValueOfSetting(settings.extraOptions.motion) }}
            br
            | {{ $i18n.t('trainer.trainer_gameFormSetting_voiceActing') }}:
            | {{ abbreviatedValueOfSetting(settings.extraOptions.voiceOver) }}
            br
        slot
</template>

<script>
    /*eslint-disable*/
    import _ from 'lodash'

    const {noun} = require('plural-ru');

    import TrainerUtilities from '../../../utils/trainer/trainer';
    import gamePreviewMixin from '../../../utils/trainer/gamePreviewMixin';

    export default {
        mixins: [TrainerUtilities, gamePreviewMixin],
        props: {
            game: Object,
            parameters: Object,
            parametersFrom: {
                type: String,
                default: 'homework'
            },
            userId: Number,
        },
        computed: {
            amountOfComplicationExercises () {
                return this.settings.tasksForComplication + ' '
                        + this.$i18n.tc('trainer.trainer_gamePreview_exampleDeclination', this.settings.tasksForComplication);
            },
            amountOfSpeedExercises () {
                return this.settings.tasksForSpeedUp + ' '
                        + this.$i18n.tc('trainer.trainer_gamePreview_exampleDeclination', this.settings.tasksForSpeedUp);
            },
            amountOfActions () {
                return this.settings.complication + ' '
                        + this.$i18n.tc('trainer.trainer_gamePreview_actionDeclination', this.settings.complication);
            },
            fractionalPart() {
                return this.settings.fractionalPart + ' '
                        + this.$i18n.tc('trainer.trainer_gamePreview_numDeclination', this.settings.fractionalPart);
            },
            jumpOver () {
                if (this.settings.jumpOver50 && this.settings.jumpOver100) {
                    return '50, 100';
                }
                if (this.settings.jumpOver50) {
                    return '50';
                }
                if (this.settings.jumpOver100) {
                    return '100';
                }
            },
            answers () {
                if (this.settings.positiveAnswers && this.settings.negativeAnswers) {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_answersAnyLowerCase');
                }
                if (this.settings.positiveAnswers) {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_answersOnlyPositiveLowerCase');
                }
                if (this.settings.negativeAnswers) {
                    return this.$i18n.t('trainer.trainer_gameFormSetting_answersOnlyNegativeLowerCase');
                }
            },
            difficult () {
                return this.settings.combining
                        ? this.getDifficultName(this.settings.difficult)
                        + ` (${this.$i18n.t('trainer.trainer_gameFormSetting_combining')})`
                        : this.getDifficultName(this.settings.difficult);
            },
            mode () {
                return  _.find(this.modes, { value: this.settings.mode })
            },
            motionLabel () {
                return this.$i18n.t('trainer.trainer_gameFormSetting_movement', {
                    element: this.$i18n.t('trainer.trainer_gameFormSettingValue_numbers')
                })
            }
        },
        methods: {
            abbreviatedValueOfSetting (setting) {
                return setting
                        ? this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated')
                        : this.$i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated');
            }
        }
    }
</script>
